import {Field, reduxForm, SubmissionError} from 'redux-form';
import PropTypes from 'prop-types';
import {Button, Divider, Form, Message, Segment} from 'semantic-ui-react';
import FormInput from '../shared/forms/input';
import {password, required} from '../shared/forms';

function PasswordForm(props) {
  const {handleSubmit, pristine, submitting, error} = props;

  async function submit({password}) {
    try {
      await props.onSubmit(password);
    } catch (error) {
      const errorMessage = error.message || 'تغییر رمز عبور انجام نشد.';
      throw new SubmissionError({_error: errorMessage});
    }
  }

  return (
    <Segment>
      <Divider horizontal content='فرم تغییر رمز عبور' className='mb-5'/>

      {/*form error*/}
      {(error && !pristine) && (
        <Message
          error
          header={error}
          className={'text-center'}
        />
      )}

      {/*form*/}
      <Form onSubmit={handleSubmit(submit.bind(null))}>
        <Field
          required
          name='password'
          type='password'
          label='رمز عبور جدید'
          component={FormInput}
          validate={[required, password]}
        />
        <Field
          required
          name='password2'
          type='password'
          label='تکرار رمز عبور جدید'
          placeholder='رمز عبور جدید خود را مجدد وارد نمایید'
          component={FormInput}
          validate={[required, password]}
        />
        <Button
          type='submit'
          disabled={pristine || submitting}
          content='تغییر رمز عبور'
        />
      </Form>
    </Segment>
  );
}

function validate(values) {
  const errors = {};
  if (values.password !== values.password2) errors.password2 = 'رمزهای عبور غیر یکسان هستند.';
  return errors;
}

PasswordForm.propTypes = {
  onSubmit: PropTypes.func.isRequired
};

export default reduxForm({form: 'password', validate})(PasswordForm);
